module.exports = __webpack_public_path__ + "static/enmax-logo-b9cf828a3e3979b789d03f9e5a285edf.jpeg";